// extracted by mini-css-extract-plugin
export var alertIcon = "_q5-0";